module.exports = __webpack_public_path__ + "static/media/LoginPageAvatarImage03.46227654.webp";